import { useState } from "react";
import React from "react";
import rightImg from "../img/aaaservices/iia4.png";

const AboutSection = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  return (
    <div
      style={{
        padding: "20px 20px",
        background: "#fff",
      }}
    >
      {/* Heading */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "50px",
        }}
      >
        <h2
          style={{
            fontSize: "40px",
            fontWeight: "700",
            margin: 0,
          }}
        >
          About{" "}
          <span
            style={{
              color: "#ff6b00",
              fontWeight: "800",
            }}
          >
            IIA
          </span>
        </h2>
      </div>

      {/* Content */}
      <div
  style={{
    maxWidth: "1350px",
    margin: "auto",
    display: "flex",
    alignItems: "center",
    gap: "50px",
    flexWrap: "wrap",
    marginTop: isMobile ? "0" : "-109px",
  }}
>
        {/* Left */}
        <div
          style={{
            flex: "1",
            minWidth: "320px",
          }}
        >
          
          <p
            style={{
              fontSize: "16px",
              lineHeight: "30px",
              color: "#555",
            }}
          >
            <span
              style={{
                color: "#ff6b00",
                fontWeight: "700",
              }}
            >
              International Institute of Automation (IIA)
            </span>{" "}
            is a premier training and skill development institute dedicated to
            preparing students and professionals for the rapidly evolving world
            of industrial automation, robotics, and advanced manufacturing.
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "30px",
              color: "#555",
            }}
          >
            At{" "}
            <span
              style={{
                color: "#ff6b00",
                fontWeight: "700",
              }}
            >
              IIA
            </span>
            , we provide industry-oriented training programs in PLC, SCADA,
            HMI, Industrial Robotics, Embedded Systems, CAD/CAM, and Digital
            Manufacturing technologies.
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "30px",
              color: "#555",
            }}
          >
            Our mission is to bridge the gap between academic learning and
            industrial requirements by delivering practical, hands-on training
            with real-time projects and expert mentorship.
          </p>

          <p
            style={{
              fontSize: "16px",
              lineHeight: "30px",
              color: "#555",
            }}
          >
            With a strong commitment to innovation, technical excellence, and
            career growth,{" "}
            <span
              style={{
                color: "#ff6b00",
                fontWeight: "700",
              }}
            >
              International Institute of Automation
            </span>{" "}
            empowers learners to become future-ready professionals in the field
            of automation and engineering.
          </p>
        </div>

        {/* Right Image */}
        <div
          style={{
            flex: "1",
            minWidth: "320px",
          }}
        >
          <img
            src={rightImg}
            alt="IIA"
            style={{
              width: "82%",
              borderRadius: "20px",
            
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutSection;